export default __webpack_public_path__ + "static/media/workflow-stage-certificate-icon.acf386f0.svg";